import React, { useContext } from "react";
import { SidebarItem } from "./SidebarItem";
import { ReactComponent as BrandLogo } from "../../assets/sidebar-nav/brand-logo.svg";
import { Link } from "react-router-dom";
import "./style.css";
import useAuth from "../../hooks/useAuth";
import { LayoutContext } from "../../context/LayoutContext";
import { UserType } from "../../utils/enum";

const SidebarNav = ({ userData, isSidebarOpen, onClose }) => {
  const { isBannerVisible } = useContext(LayoutContext);
  const { authRoutes, authRole } = useAuth();

  return (
    <>
      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black/40 z-30 sm:hidden" onClick={onClose} />
      )}
      <div
        className={`w-24 h-screen fixed left-0 border-r border-zinc-300 z-40 bg-white transition-transform duration-300 ${
          isBannerVisible ? "top-[50px]" : "top-0"
        } ${isSidebarOpen ? "translate-x-0" : "-translate-x-full sm:translate-x-0"}`}
      >
        <Link style={{ textDecoration: "none" }}>
          <div className="flex justify-center mt-1 text-gray-950 border-b border-zinc-300 pb-[16px] pt-[14px] mb-3 text-sm h-[106px]">
            {authRole === UserType.FREELANCER ||
            authRole === UserType.ADMIN ||
            authRole === UserType.CUSTOMER ? (
              <BrandLogo />
            ) : (
              <img src={userData?.company?.logo} />
            )}
          </div>
        </Link>

        <div className="px-2">
          {authRoutes?.map((route, index) => (
            <div key={index}>
              {/* {(route?.childs?.length > 0 || authRole === UserType.FREELANCER) && ( */}
              <SidebarItem
                isShowClient={route.isShowClient}
                isShowCustomer={route.isShowCustomer}
                isShow={route.isShow}
                key={route.path + index}
                path={route.path}
                icon={route.icon}
                activeIcon={route.activeIcon}
                text={route.text}
                childs={route.childs}
              />
              {/* )} */}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SidebarNav;
